module.exports = __webpack_public_path__ + "static/media/capa-light.a177c48c.jpg";